import styled from 'styled-components';

export const StyledCounterItem = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;

    @media (max-width: 979px) {
        max-width: 100%;
        flex: 0 0 100%;
        margin-bottom: 20px;
    }
`;

export const StyledSubtitle = styled.p`
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    text-align: center;
    margin: 0;
`;

export const StyledTextNumber = styled.p`
    font-size: 2.125rem;
    line-height: 3rem;
    font-weight: 600;
    text-align: center;
    margin: 0;
    color: ${props => props.theme.colors.primary};
`;

export const StyledSpanNumber = styled.span`
    font-size: 3rem;
    font-weight: 600;
    line-height: 1.28;
`;
